import { OrganizationsList } from './components/OrganizationsList.tsx';

import { BasePage } from '#src/components/BasePage/BasePage.tsx';
import type { Breadcrumb } from '#src/components/Breadcrumbs/Breadcrumbs.tsx';

export const OrganizationsPage = ({
  breadcrumbs,
}: {
  breadcrumbs: Breadcrumb[];
}) => (
  <BasePage title="Organizations" breadcrumbs={breadcrumbs}>
    <OrganizationsList />
  </BasePage>
);
